export default "__VITE_ASSET__a9a4ddd1__"